import { TokenInfo } from "../../../config/arbitrum.types";
import InputMaxButton from "./InputMaxButton";

type Props = {
  handleClick?: ((balance: string) => void) | void;
  activeToken: TokenInfo;
};

const InputMaxButtonArbitrum = ({ handleClick, activeToken }: Props) => {
  return (
    <InputMaxButton
      handleClick={handleClick}
      assetName={activeToken.name}
      assetCurrency={activeToken.displayName}
      assetDecimals={activeToken.decimals}
    />
  );
};

export default InputMaxButtonArbitrum;
